import React, { ChangeEvent, useCallback, useMemo } from 'react';
import { Box } from '@televet/kibble-ui/build/chakra';
import { Textarea } from '@televet/kibble-ui/build/components/Textarea';
import { useSurveySettingsContext } from 'pages/Survey/context/SurveySettingsContext';
import WildcardTextInput, {
  WildcardInputPreviewModes,
  WildcardInputQuestionTypes,
} from 'pages/Forms/FormsContent/FormsDrafting/WildcardInputs/WildcardTextInput';
import { SurveyType } from 'shared/types/graphql';

interface IFeedbackStepProps {
  feedback: string;
  setFeedback: React.Dispatch<React.SetStateAction<string>>;
  rating: number;
}

const FeedbackStep = ({ feedback, setFeedback, rating }: IFeedbackStepProps): JSX.Element => {
  const { composeSettings, surveyType } = useSurveySettingsContext();

  const prompt = useMemo(
    () =>
      rating >= (surveyType === SurveyType.Nps ? 7 : 3)
        ? composeSettings.positiveQuestion
        : composeSettings.negativeQuestion,
    [composeSettings.negativeQuestion, composeSettings.positiveQuestion, rating, surveyType],
  );

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => setFeedback(event.target.value),
    [setFeedback],
  );

  return (
    <Box className="preview__form-step" id="survey-preview-step-feedback">
      <WildcardTextInput
        text={prompt}
        type={WildcardInputQuestionTypes.Question}
        previewMode={WildcardInputPreviewModes.Survey}
      />
      <Textarea placeholder="Type your response here..." defaultValue={feedback} onBlur={handleChange} mt={6} />
    </Box>
  );
};

export default FeedbackStep;
